import { useCallback, useContext } from 'react'
import { StoreContext } from '../../StoreProvider'
import { casinoStoreKey } from '../casinoStoreConstants'
import { updateZustandState } from '../../storeUtils'
import { updateZustandLocalStorage } from '../../localStorageUtils'

export const useSetCasinoData = () => {
  const { store } = useContext(StoreContext)

  const getUpdatedData = (state, actionData) => {
    const output = updateZustandState(state, actionData)

    updateZustandLocalStorage(casinoStoreKey, output)

    return output
  }

  const setCasinoData = useCallback(
    (actionData, actionName) => {
      store.setState(
        state => ({
          ...state,
          [casinoStoreKey]: getUpdatedData(state[casinoStoreKey], actionData)
        }),
        false,
        actionName || casinoStoreKey
      )
    },
    [store]
  )

  return { setCasinoData }
}
